import React from "react";

const VisibleContent = ({ visible, children }) => {
	return Boolean(visible) ? children : null
}

export default VisibleContent
